<main class="loginBannerBg" role="main">
    <h1 class="cdk-visually-hidden">Reset your password</h1>
    <div class="container d-flex justify-content-center">
        <div class="d-flex flex-column">
            <div>
                <mat-card class="mat-elevation-z0">
                    <template [ngTemplateOutlet]="logos"></template>
                    <mat-card-content>
                        <form [formGroup]="passwordForm">
                            <div class="flex-col">
                                <mat-form-field appearance="outline" class="w-100" color="primary">
                                    <mat-label>New Password</mat-label>
                                    <input #password autocomplete="new-password" formControlName="password" matInput
                                           type="password">
                                    @if (passwordForm.controls['password'].hasError('required')) {
                                        <mat-error>
                                            This field is required
                                        </mat-error>
                                    }
                                </mat-form-field>
                                <mat-form-field appearance="outline" class="w-100" color="primary">
                                    <mat-label>Confirm New Password</mat-label>
                                    <input #confirmPassword autocomplete="new-password"
                                           formControlName="confirmPassword"
                                           matInput type="password">
                                    @if (passwordForm.controls['confirmPassword'].hasError('required')) {
                                        <mat-error>
                                            This field is required
                                        </mat-error>
                                    }
                                </mat-form-field>
                            </div>
                            <app-password-validator [length]="this.passwordLength"
                                                    [matching]="password.value != confirmPassword.value"
                                                    [password]="password.value"></app-password-validator>
                        </form>
                    </mat-card-content>
                    <mat-card-actions class="text-center">
                        <button (click)="resetPassword()" [attr.aria-busy]="loading"
                                [disabled]="passwordForm.invalid || loading"
                                class="mx-auto my-10"
                                color="primary" mat-flat-button type="submit">
                            Update Password
                            @if (loading) {
                                <mat-spinner [diameter]="24" aria-label="Saving" class="ms-2"></mat-spinner>
                            }
                        </button>
                    </mat-card-actions>
                </mat-card>
            </div>
        </div>
    </div>
</main>
<app-footer></app-footer>

<ng-template #logos>
    <div class="col-row logosGrid">
        <img alt="Virtual Memory Box Logo" class="my-10 logo" src="assets/images/vmb.png">
        <!--        <img *ngIf="councilLogo" [alt]=" + ' Logo'" [src]="councilLogo" class="my-10 logo">-->
    </div>
</ng-template>
